import { Box, useMediaQuery } from '@mui/material';
import Champs from './champs';
import Clubs from './clubs';
import EpicRewards from './epicRewards';
import FunLearning from './funLearning';
import Latest from '../../components/latest';
import Platform from './platform';
import Playground from './playgournd';
import Popular from './newPopular';
import React from 'react';
import Talent from './talent';
import Team from './team';
import TopBooks from './top-books';
import TopClans from './top-clans';
import TopLandscapes from './top-landscapes';
import TopPortraits from './top-portraits';
import TopQuest from './top-quest';
import TrendingHot from '../../components/trending-hot';
import Prices from './prizes';

const Content = (props: { isMobile: any }) => {
  const isMobile = props.isMobile;
  return (
    <Box
      sx={{
        backgroundSize: 'repeat',
        backgroundPosition: 'center center',
        zIndex: 0
      }}>
      <TopQuest />
      <Prices />
      <Platform isMobile={isMobile} />
      <Champs />
      <FunLearning isMobile={isMobile} />
      <Clubs />
      <Team isMobile={isMobile} />
      <TrendingHot />
      <EpicRewards isMobile={isMobile} />
      <TopPortraits />
      <Playground isMobile={isMobile} />
      <TopLandscapes />
      <Talent isMobile={isMobile} />
      <Popular />
      <TopClans isMobile={isMobile} />
      <TopBooks />
      <Latest />
    </Box>
  );
};

const Home = () => {
  const isMobile = useMediaQuery('(max-width:600px)');
  return isMobile ? (
    <Box sx={{}}>
      <Content isMobile={isMobile} />
    </Box>
  ) : (
    <Box
      sx={{
        margin: 0,
        padding: 0
      }}>
      <Content isMobile={isMobile} />
    </Box>
  );
};

export default Home;
